module.exports = __webpack_public_path__ + "img/Gif1.56f07520.gif";